import React from 'react';
import PageContainer from '../../common/components/Page/PageContainer';
import PermissionsRoleContainer from './components/PermissionsRoleContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import './Permissions.css';

const Permissions = () => (
  <PageContainer pageName="permissions">
    <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_PERMISSIONS}>
      <PermissionsRoleContainer />
    </PermissionsCheck>
  </PageContainer>
);

export default Permissions;
